<template lang="pug">
section#v-topics: .container
  #swiper-1.swiper
    h3 2019 智慧製造論壇會後報導
    p 科技報橘 2019 智慧製造實體論壇，探討台灣製造升級全新商機與轉型關鍵。
    .swiper-container
      .swiper-wrapper
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2019/03/15/smart-manufacturing-3/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2019/03/panel-1-1024x683.jpeg")')
            h4 【2019 智慧製造論壇】5G 將是 Game Changer，改變台灣產業協作新模式
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2019/03/15/smart-manufacturing-5g/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2019/03/%E8%81%AF%E7%99%BC%E7%A7%91-1024x683.jpeg")')
            h4 【2019 智慧製造論壇】備戰 5G 智慧未來，台灣關鍵下一步是什麼？
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2019/03/15/smart-manufacturing-ai/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2019/03/panel-2-1024x683.jpeg")')
            h4 【2019 智慧製造論壇】製造業的「管理」全面顛覆，台灣供應鏈 AI 自動化的關鍵是什麼？
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2019/03/15/smart-manufacturing-2/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2019/03/Panel-3-1024x674.jpeg")')
            h4 【2019 智慧製造論壇】工業 4.0 時代的人機協作：以消費者為核心，重塑資料分析模型
      .swiper-scrollbar
    .swiper-button-prev
    .swiper-button-next
  #swiper-2.swiper
    h3 5G 智慧未來
    p 5G 解放產線連接速度，進一步實現高度自動化，提升生產靈活度、降低成本。
    .swiper-container
      .swiper-wrapper
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2019/02/23/5g-aiot/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2019/02/388-1024x637.jpg")')
            h4 當 5G 加上邊緣運算，「智慧工廠」概念將被重新顛覆一次
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2019/02/19/5g-factory/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2019/02/380-768x512.jpg")')
            h4 英國首座 5G 工廠實驗開始！《富比士》：這會是第四次工業革命
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2019/02/15/foxconn-5g-factory/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2019/02/20190214000112-768x586.jpg")')
            h4 台廠轉型最大契機！鴻海深耕 5G 智慧製造，今年將設實驗廠
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2019/03/07/chunghwa-5g/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2019/03/%E4%B8%AD%E8%8F%AF%E9%9B%BB%E4%BF%A15G-768x512.jpg")')
            h4 【台灣第一間！】邁向 2020 商用目標，中華電信完成台灣首次 5G 終端裝置聯網
      .swiper-scrollbar
    .swiper-button-prev
    .swiper-button-next
  #swiper-3.swiper
    h3 AI 自動化供應鏈實戰精華
    p 整合產線現有優勢，供應鏈如何從自動化跨過智慧化製造門檻？
    .swiper-container
      .swiper-wrapper
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2019/01/23/collaborate-with-ai/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2019/01/28077961816_5f03845f13_b.jpg")')
            h4 智慧製造新物種：台灣製造業轉型，需要哪種斜槓人才？
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2019/01/17/industry-3-5-improve-manufacture/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2019/01/%E7%B4%A1%E7%B9%94-1024x576.jpg")')
            h4 台灣傳產人才斷層靠智慧製造解決！提升資源調度彈性，減少依賴老師傅經驗
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2018/11/07/delta-electronics-and-smart-manufacturing/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2018/11/272989-1024x498.jpg")')
            h4 台達推出「二機一手」機器人工作站，節省軟體成本和產線建置時間！
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2019/03/07/trends-of-industry-4-0/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2019/02/Manufacturing_equipment.jpg")')
            h4 全自動化工廠搶著要怎樣的人才？帶你了解智慧製造的 7 大趨勢
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2019/03/06/smart-manufacture-motorcycle/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2019/03/%E6%9D%B1%E5%8F%B0%E7%B2%BE%E6%A9%9F-1024x683.jpg")')
            h4 機車升級智慧製造！東台、光陽聯手打造全台首條機車智慧生產線
      .swiper-scrollbar
    .swiper-button-prev
    .swiper-button-next
  #swiper-4.swiper
    h3 人/機協作新策略
    p 製造業自動化進程需要人機協作、混合AI 才能邁向工業 4.0
    .swiper-container
      .swiper-wrapper
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2019/02/21/rpa/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2019/02/383.jpg")')
            h4 智慧製造轉型前哨戰：導入 AI、物聯網之前，你有想過導入 RPA 嗎？
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2019/02/20/festo/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2019/02/381-1024x602.jpg")')
            h4 讓機械手臂「到處走」，工業 4.0 時代人機協作的全新可能性
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2018/07/30/factory-in-the-future/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2018/07/%E6%99%BA%E6%85%A7%E5%B7%A5%E5%BB%A0-%E6%9C%AA%E4%BE%86-%E5%B7%A5%E5%BB%A0-%E6%A9%9F%E5%99%A8-%E5%BB%A0%E6%88%BF-%E8%87%AA%E5%8B%95%E5%8C%96.jpg")')
            h4 智慧工廠背後的管理深思：重點不是自動化，而是工廠的「統一大腦」
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2018/02/01/babo-arms/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2018/02/IMG_9884-1-1024x768.jpg")')
            h4 台灣第一家無人珍奶店 Babo Arms，機械手臂搖的珍奶你有喝過？
        .swiper-slide
          a(href='https://buzzorange.com/techorange/2018/02/01/babo-arms/', target='_blank')
            figure(style='background-image: url("https://buzzorange.com/techorange/wp-content/uploads/sites/2/2019/01/51043315_400089087473471_6013112522599563264_n-768x576.jpg")')
            h4 【專訪車王電董事長蔡裕慶】超有台灣特色，車王電的人機整合技術是什麼？
      .swiper-scrollbar
    .swiper-button-prev
    .swiper-button-next
</template>

<script>
import Swiper from 'swiper'

export default {
  name: 'Topics',
  methods: {
    getSwiperConfig(i) {
      return {
        longSwipesMs: 100,
        longSwipesRatio: 0.2,
        shortSwipes: false,
        slidesPerView: 'auto',
        spaceBetween: 30,
        navigation: {
          prevEl: `#swiper-${i} .swiper-button-prev`,
          nextEl: `#swiper-${i} .swiper-button-next`,
        },
        scrollbar: {
          el: `#swiper-${i} .swiper-scrollbar`,
          hide: true,
        },
        breakpoints: {
          999: {
            freeMode: true,
            spaceBetween: 10,
          }
        }
      }
    },
  },
  mounted() {
    new Swiper('#swiper-1 .swiper-container', this.getSwiperConfig(1))
    new Swiper('#swiper-2 .swiper-container', this.getSwiperConfig(2))
    new Swiper('#swiper-3 .swiper-container', this.getSwiperConfig(3))
    new Swiper('#swiper-4 .swiper-container', this.getSwiperConfig(4))
  },
}
</script>

<style lang="sass" scoped>
@import '~@/mixin.sass'

#v-topics
  padding-bottom: 80px
  padding-top: 60px
h3
  +font(24px, #FF9106, null, .24px, bold)
  margin-bottom: 10px
p
  +font(20px, #656565, null, .2px, 500)
  margin-bottom: 30px
  position: relative
a
  display: block
  width: 300px
  figure
    +background(null, cover, null, center top)
    display: block
    height: 160px
  h4
    +font(18px, #4B4B4B, 26px, .17px, null, justify)
    background-color: #EDEDED
    box-sizing: border-box
    height: 110px
    padding: 12px 15px 0

.swiper
  position: relative
  &:not(:last-child)
    margin-bottom: 50px
.swiper-slide
  width: auto
.swiper-button-next
  bottom: 110px
  outline: none
  right: -54px
  top: unset
.swiper-button-prev
  bottom: 110px
  left: -54px
  outline: none
  top: unset
.swiper-scrollbar
  display: none !important

@media (max-width: 1023px)
  #v-topics
    padding-bottom: 40px
    padding-top: 60px
  h3
    +font(16px, null, 14px, .15px)
    margin-bottom: 5px
  p
    +font(12px, null, 18px, .11px)
    margin-bottom: 20px
  a
    width: 210px
    figure
      height: 112px
    h4
      +font(12px, #4B4B4B, 18px, .11px)
      height: 77px
      padding: 8px 10px 0

  .swiper
    &:not(:last-child)
      margin-bottom: 40px
  .swiper-container
    padding-bottom: 15px
  .swiper-button-prev, .swiper-button-next
    display: none !important
  .swiper-scrollbar
    display: block !important
</style>
